import React from 'react';
import styles from './Footer.module.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Main Footer Content */}
        <div className={styles.footerContent}>
          <div className={styles.footerGrid}>
            {/* Company Info */}
            <div className={styles.footerColumn}>
              <div className={styles.logoSection}>
                <div className={styles.footerLogo}>
                  <span className={styles.logoText}>
                    <span className={styles.dollarS}>$</span>TONE
                  </span>
                  <span className={styles.logoAccent}>
                    <span className={styles.euroF}>€</span>OREX
                  </span>
                </div>
                <p className={styles.companyDescription}>
                  Professional trading platform providing access to global financial markets 
                  with competitive spreads and institutional-grade execution.
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.footerColumn}>
              <h3>Trading</h3>
              <ul>
                <li><a href="#">Forex</a></li>
                <li><a href="#">Stocks</a></li>
                <li><a href="#">Commodities</a></li>
                <li><a href="#">Indices</a></li>
                <li><a href="#">Cryptocurrencies</a></li>
              </ul>
            </div>

            <div className={styles.footerColumn}>
              <h3>Platforms</h3>
              <ul>
                <li><a href="#">MetaTrader 4</a></li>
                <li><a href="#">MetaTrader 5</a></li>
                <li><a href="#">Web Platform</a></li>
                <li><a href="#">Trading Tools</a></li>
              </ul>
            </div>

            <div className={styles.footerColumn}>
              <h3>Support</h3>
              <ul>
                <li><a href="#">Help Center</a></li>
                <li><a href="#">Live Chat</a></li>
                <li><a href="#">Contact Us</a></li>
                <li><a href="#">Account Issues</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className={styles.footerColumn}>
              <h3>Contact</h3>
              <div className={styles.contactInfo}>
                <p>📍 350W, 1st Street, Los Angeles, CA</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className={styles.footerBottom}>
          <div className={styles.bottomContent}>
            <div className={styles.copyrightSection}>
              <p>&copy; {currentYear} StoneForex. All rights reserved.</p>
              <div className={styles.legalLinks}>
                <a href="#">Privacy Policy</a>
                <span>•</span>
                <a href="#">Terms of Service</a>
                <span>•</span>
                <a href="#">Risk Warning</a>
              </div>
            </div>
          </div>
          
          {/* Simple Risk Warning */}
          <div className={styles.riskWarning}>
            <p>
              <strong>Risk Warning:</strong> Trading involves significant risk and may result in the loss of your invested capital. 
              You should not invest more than you can afford to lose. Please read our Risk Disclosure documents.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
